import { X } from "lucide-react";
import type { ReactNode } from "react";
import { IconButton } from "../../components/IconButton/IconButton";

export type BannerVariant = "brand" | "info" | "success" | "warning" | "error";

const VARIANT_CLASSES: Record<BannerVariant, string> = {
  brand: "bg-brand-primary-subtle text-brand-primary-on-subtle",
  info: "bg-info-subtle text-info-on-subtle",
  success: "bg-success-subtle text-success-on-subtle",
  warning: "bg-warning-subtle text-warning-on-subtle",
  error: "bg-error-subtle text-error-on-subtle",
};

export interface BannerProps {
  variant?: BannerVariant;

  icon?: ReactNode;
  message: string;

  action?: ReactNode;

  onDismiss?: () => void;
  /** Accessible name for the dismiss button. */
  dismissLabel?: string;
}

export function Banner({
  variant = "brand",
  icon,
  message,
  action,
  onDismiss,
  dismissLabel = "Dismiss",
}: Readonly<BannerProps>) {
  return (
    <div
      className={`flex shrink-0 items-center gap-2.5 border-b border-border-subtle py-1.5 pr-2 pl-3.5 ${VARIANT_CLASSES[variant]}`}
    >
      {icon && <span className="flex shrink-0 items-center">{icon}</span>}
      {}
      <span className="min-w-0 flex-1 truncate pt-px [font:var(--type-caption)]">{message}</span>
      {action && <span className="flex shrink-0 items-center">{action}</span>}
      {onDismiss && <IconButton icon={<X />} aria-label={dismissLabel} variant="ghost" size="sm" onClick={onDismiss} />}
    </div>
  );
}
